import { render, staticRenderFns } from "./NotariosPage.vue?vue&type=template&id=0f7ba396"
import script from "./NotariosPage.vue?vue&type=script&lang=js"
export * from "./NotariosPage.vue?vue&type=script&lang=js"
import style0 from "./NotariosPage.vue?vue&type=style&index=0&id=0f7ba396&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports